import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_table_column_group');

register('wm-table-column-group', (): IBuildTaskDef => {
    return {
        pre: (attrs: any) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmTableColumnGroup #${counter}="wmTableColumnGroup" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
